import ShareRounded from '@mui/icons-material/ShareRounded';
import MLToast from 'components/common/Toast/Toast';
import TSButton from 'components/common/Button/Button';
import { ROUTES } from 'constants/RoutePaths';

// The Plan's Shared Plan page link, for the walker to send to anyone. Opens
// the device's share sheet where there is one, otherwise copies the link.
const SharePlan = ({ shareToken, trailName }) => {
  const { showToast } = MLToast();
  const url = `${window.location.origin}/${ROUTES.SHARED_PLAN.replace(
    ':token',
    shareToken
  )}`;

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: `My walk: ${trailName}`, url });
      } catch (err) {
        // Closing the share sheet isn't an error worth showing.
        if (err.name !== 'AbortError')
          showToast("Couldn't share the link", 'error');
      }
      return;
    }
    try {
      await navigator.clipboard.writeText(url);
      showToast('Link copied', 'success');
    } catch {
      showToast(`Couldn't copy the link: ${url}`, 'error', 10000);
    }
  };

  return (
    <TSButton
      btnText="Share Plan"
      btnVariant="outlined"
      icon={<ShareRounded />}
      onClickFunc={handleShare}
    />
  );
};

export default SharePlan;
